<template>
  <section class="ren-decoration-cp ren-decoration-cp-ticketing-hero">
    <img v-if="imageUrl" :src="imageUrl" alt="" />
    <div>
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
    </div>
    <button type="button">{{ buttonText }}</button>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '景区官方店'))
const subtitle = computed(() => stringValue(props.component.props?.subtitle))
const buttonText = computed(() => stringValue(props.component.props?.buttonText, '立即购票'))
const imageUrl = computed(() => widgetMediaUrl(props.component.props?.imageUrl))
</script>

<style scoped>
.ren-decoration-cp-ticketing-hero {
  display: grid;
  gap: 8px;
  min-height: 120px;
}
.ren-decoration-cp-ticketing-hero img {
  width: 100%;
  max-height: 140px;
  object-fit: cover;
}
.ren-decoration-cp-ticketing-hero span {
  color: var(--ren-theme-muted);
  font-size: 12px;
}
.ren-decoration-cp-ticketing-hero button {
  justify-self: start;
  border: 0;
  border-radius: 6px;
  padding: 8px 12px;
  background: var(--ren-theme-primary);
  color: #fff;
}
</style>
